module.exports = __webpack_public_path__ + "img/indicador.3e0eae69.jpg";